import React, { FC } from 'react';
import { TypeImage, TypeQuoteCardFields } from '@/core/generated-types';
import { Image } from '@/components/ui/Image';
import classNames from 'classnames';

const QuoteCard: FC<TypeQuoteCardFields> = ({
  quote,
  image,
  attribution,
  enlargeName,
  addShadow,
}) => {
  return (
    <div
      className={classNames(
        'mx-2 my-2 grid grid-rows-auto content-baseline w-full overflow-hidden rounded-lg bg-white md:mx-8 md:max-w-[360px]',
        {
          'drop-shadow-md': addShadow,
        },
      )}
      data-testid="quotecard"
    >
      {image && (
        <Image
          alt={image?.fields?.altText}
          className="h-auto w-full flex-none"
          imageData={image as TypeImage}
        />
      )}
      {!enlargeName ? (
        <div className="relative flex-auto p-4 pb-14 text-center text-base md:p-6 md:pb-16">
          <p>{quote}</p>
          <p className="absolute bottom-6 left-0 w-full text-center text-sm font-bold md:text-base">
            {attribution}
          </p>
        </div>
      ) : (
        <div className="p-4 text-base md:p-6 text-center">
          <div className="text-lg font-bold text-blue-deep mb-4">
            {attribution}
          </div>
          <div>{quote}</div>
        </div>
      )}
    </div>
  );
};

export default React.memo(QuoteCard);
